export default __webpack_public_path__ + "static/media/landing2.4c43ed01.jpg";